"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ms = _interopRequireDefault(require("ms"));
var _occasion = _interopRequireDefault(require("occasion"));
var _gbp = _interopRequireDefault(require("gbp"));
var _formatDateTime = _interopRequireDefault(require("../../../../../utils/formatDateTime"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// the styled components are purely to improve the layout of the printed version of the start list
// Tr shrinks all the table rows. Tbody should stop breaks within each group but does not always do so
// successfully (depends on browser).
const Tr = _styledComponents.default.tr`
  @media print {
    font-size: 0.6em;
    line-height: 1em;
  }
`;
const Tbody = _styledComponents.default.tbody`
  @media print {
    page-break-inside: avoid;
  }
`;
class Payment extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_msSince", thisdatetime => {
      let msSince = 0;
      if (thisdatetime) {
        msSince = new Date(thisdatetime).getTime();
        msSince = Math.max(Date.now() - msSince, 0);
      }
      return msSince;
    });
    _defineProperty(this, "_getRefundStatusClass", refundStatusRef => {
      if (refundStatusRef === 'RFND') return 'text-xs-right text-success';
      if (refundStatusRef === 'RVRT') return 'text-xs-right text-success';
      if (refundStatusRef === 'ERRR') return 'text-xs-right text-danger';
      return 'text-xs-right';
    });
    _defineProperty(this, "_getEntryStatusClass", entryStatusRef => {
      if (entryStatusRef === 'COMP') return 'text-success';
      if (entryStatusRef === 'CANN' || entryStatusRef === 'CANR') return 'text-danger';
      return '';
    });
  }
  render() {
    const payment = this.props.payment;
    const paymentStatusClass = payment.paymentStatusRef === 'PAID' ? 'text-xs-right text-success' : payment.paymentStatusRef === 'ERR' ? 'text-xs-right text-danger' : 'text-xs-right';
    const numOfEntries = payment && payment.entries.length;
    const numOfRefunds = payment && payment.refunds.length;
    const numOfPaymentRows = Math.max(numOfEntries, numOfRefunds);
    const paymentRows = [];
    for (let i = 0; i < numOfPaymentRows; i++) {
      paymentRows[i] = {};
    }

    // If the number of refunds/reinstatements are greater than entries then
    // the first row for entries needs to span several rows.
    // Subsequent entries will be starting on a later row to account for this
    payment.entries.map((entry, i) => {
      const rowNum = i === 0 ? 0 : numOfPaymentRows - numOfEntries + i;
      entry.rowSpan = i === 0 ? numOfPaymentRows - numOfEntries + 1 : 1;
      paymentRows[rowNum].entry = entry;
    });
    let refunded = 0;
    payment.refunds.map((refund, i) => {
      const rowNum = i === 0 ? 0 : numOfPaymentRows - numOfRefunds + i;
      refund.rowSpan = i === 0 ? numOfPaymentRows - numOfRefunds + 1 : 1;
      paymentRows[rowNum].refund = refund;
      refunded += refund.refundedByClub;
    });
    var _ref = /*#__PURE__*/_react.default.createElement("td", {
      className: "cell-border-left",
      rowSpan: numOfPaymentRows,
      colSpan: 3
    });
    return /*#__PURE__*/_react.default.createElement(Tbody, {
      className: this._msSince(payment.errorNotifiedDate) > (0, _ms.default)('48h') && payment.paymentStatusRef === 'ERR' ? 'table-danger' : ''
    }, /*#__PURE__*/_react.default.createElement(Tr, {
      className: "table-success"
    }, /*#__PURE__*/_react.default.createElement("td", {
      style: {
        verticalAlign: 'bottom'
      },
      colSpan: 11
    })), paymentRows.map((row, i) => /*#__PURE__*/_react.default.createElement(Tr, {
      key: i
    }, !row.entry ? null : [/*#__PURE__*/_react.default.createElement("td", {
      key: 'race-' + i,
      style: {
        verticalAlign: 'bottom'
      },
      rowSpan: row.entry.rowSpan
    }, (0, _occasion.default)(row.entry.race.competitionDay.dayDate, 'ddd') + ' ' + row.entry.race.raceName), /*#__PURE__*/_react.default.createElement("td", {
      key: 'bib-' + i,
      style: {
        verticalAlign: 'bottom'
      },
      rowSpan: row.entry.rowSpan
    }, row.entry.bibNumber || ''), /*#__PURE__*/_react.default.createElement("td", {
      key: 'name-' + i,
      style: {
        verticalAlign: 'bottom'
      },
      rowSpan: row.entry.rowSpan
    }, row.entry.bibName), /*#__PURE__*/_react.default.createElement("td", {
      key: 'entry-status-' + i,
      style: {
        verticalAlign: 'bottom'
      },
      rowSpan: row.entry.rowSpan,
      className: this._getEntryStatusClass(row.entry.entryStatusRef)
    }, row.entry.entryStatus.description)], i !== 0 ? null : [/*#__PURE__*/_react.default.createElement("td", {
      key: "payment-date",
      style: {
        verticalAlign: 'bottom'
      },
      className: paymentStatusClass + ' cell-border-left',
      rowSpan: numOfPaymentRows
    }, (0, _formatDateTime.default)(payment.createdDate)), /*#__PURE__*/_react.default.createElement("td", {
      key: "payment-amount",
      style: {
        verticalAlign: 'bottom'
      },
      className: paymentStatusClass,
      rowSpan: numOfPaymentRows
    }, (0, _gbp.default)(payment.expectedForClub)), /*#__PURE__*/_react.default.createElement("td", {
      key: "payment-status",
      style: {
        verticalAlign: 'bottom'
      },
      className: paymentStatusClass,
      rowSpan: numOfPaymentRows
    }, payment.paymentStatusDescription)], !row.refund ? i !== 0 ? null : _ref : [/*#__PURE__*/_react.default.createElement("td", {
      key: 'refund-date-' + i,
      style: {
        verticalAlign: 'bottom'
      },
      className: this._getRefundStatusClass(row.refund.refundStatusRef) + ' cell-border-left',
      rowSpan: row.refund.rowSpan
    }, (0, _formatDateTime.default)(row.refund.refundDate)), /*#__PURE__*/_react.default.createElement("td", {
      key: 'refund-amount-' + i,
      style: {
        verticalAlign: 'bottom'
      },
      className: this._getRefundStatusClass(row.refund.refundStatusRef),
      rowSpan: row.refund.rowSpan
    }, (0, _gbp.default)(row.refund.refundedByClub)), /*#__PURE__*/_react.default.createElement("td", {
      key: 'refund-status-' + i,
      style: {
        verticalAlign: 'bottom'
      },
      className: this._getRefundStatusClass(row.refund.refundStatusRef),
      rowSpan: row.refund.rowSpan
    }, row.refund.refundStatusDescription)], i !== 0 ? null : /*#__PURE__*/_react.default.createElement("th", {
      key: "balance",
      style: {
        verticalAlign: 'bottom'
      },
      className: 'text-xs-right cell-border-left',
      rowSpan: numOfPaymentRows
    }, (0, _gbp.default)(payment.expectedForClub - refunded)))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(Payment, "partialQueries", {
  Payment: {
    id: true,
    expectedForClub: true,
    paymentStatusRef: true,
    paymentStatusDescription: true,
    errorNotifiedDate: true,
    createdDate: true,
    refunds: {
      id: true,
      refundedByClub: true,
      refundDate: true,
      refundStatusRef: true,
      refundStatusDescription: true
    },
    entries: {
      id: true,
      bibNumber: true,
      bibName: true,
      entryStatusRef: true,
      entryStatus: {
        description: true
      },
      race: {
        raceName: true,
        competitionDay: {
          dayDate: true
        }
      }
    }
  }
});
var _default = exports.default = Payment;